var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-editor',{attrs:{"fields":_vm.fields,"publication":true,"permission":"press","endpoint":"press","module":"press","previewModule":"pers","selectTags":false,"selectCategories":false},on:{"update":_vm.updateState}})
}
var staticRenderFns = []

export { render, staticRenderFns }